import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceService } from '../service.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-employee-kpi-edit',
  templateUrl: './employee-kpi-edit.component.html',
  styleUrls: ['./employee-kpi-edit.component.css']
})
export class EmployeeKpiEditComponent implements OnInit {
  constructor(private brandService: ServiceService, private router: Router, private route: ActivatedRoute) { }

  public model = [];
  minDate = new Date()
  maxDate = new Date()
  calenderShown = false
  output: any = []; //---store get() result--------
  DName = "*"
  MName = "*"
  Date = ""

  data = {
    _id: "",
    count_list: Array()
  }

  isShown: boolean = false;
  alert = ""
  message = ""
  department: any = [];

  getdata: any = [];
  setData: any;
  array: any;
  parts = Array()
  Data: any
  user_Type = ""
  Id = null


  //---------function for edit brand detail-----
  btnClick(Array: any) {

    this.data.count_list = []
    console.log("Array=", Array)
    if (this.user_Type == "Sales_Promoter") {
      var obj = {
    "date_formated": Array.date_formated || Array.date,
    "Unposted_invoices": Array.Unposted_invoices !== undefined ? Array.Unposted_invoices : 0,
    "hardcopy_not_received_invoices": Array.hardcopy_not_received_invoices !== undefined ? Array.hardcopy_not_received_invoices : 0,
    "rfr_over_due_count": Array.rfr_over_due_count !== undefined ? Array.rfr_over_due_count : 0,
    "rfr_missed_kpi_point": Array.rfr_missed_kpi_point !== undefined ? Array.rfr_missed_kpi_point : 0,
    "rft_over_due_count": Array.rft_over_due_count !== undefined ? Array.rft_over_due_count : 0,
    "rft_missed_kpi_point": Array.rft_missed_kpi_point !== undefined ? Array.rft_missed_kpi_point : 0,
    "employee_attendance_point": Array.employee_attendance_point !== undefined ? Array.employee_attendance_point : 0,
    "visitPlanWaitingpoint": Array.visitPlanWaitingpoint !== undefined ? Array.visitPlanWaitingpoint : 0,
    "visitplanApprovedPoint": Array.visitplanApprovedPoint !== undefined ? Array.visitplanApprovedPoint : 0,
    "projection_kpi_point": Array.projection_kpi_point !== undefined ? Array.projection_kpi_point : 0,
    "inv_transfer_trip_kpi_point": Array.inv_transfer_trip_kpi_point !== undefined ? Array.inv_transfer_trip_kpi_point : 0,
    "sale_order_kpi_point": Array.sale_order_kpi_point !== undefined ? Array.sale_order_kpi_point : 0,
      }
      this.data.count_list.push(obj)
      console.log("data1=", this.data)
      //return
      this.brandService.updateEmployeeKpi(this.data).subscribe((res) => {
        this.alert = res.message;
        console.log("res=", res);
        this.MonthSelected()
        Swal.fire('Done!', res.message, 'success')

      })
    }
    else {
  var obj1 = {
    "date_formated": Array.date_formated || Array.date,
    "Unposted_invoices": Array.Unposted_invoices !== undefined ? Array.Unposted_invoices : 0,
    "hardcopy_not_received_invoices": Array.hardcopy_not_received_invoices !== undefined ? Array.hardcopy_not_received_invoices : 0,
    "rfr_over_due_count": Array.rfr_over_due_count !== undefined ? Array.rfr_over_due_count : 0,
    "rfr_missed_kpi_point": Array.rfr_missed_kpi_point !== undefined ? Array.rfr_missed_kpi_point : 0,
    "rft_over_due_count": Array.rft_over_due_count !== undefined ? Array.rft_over_due_count : 0,
    "rft_missed_kpi_point": Array.rft_missed_kpi_point !== undefined ? Array.rft_missed_kpi_point : 0,
    "employee_attendance_point": Array.employee_attendance_point !== undefined ? Array.employee_attendance_point : 0,
    "visitPlanWaitingpoint": Array.visitPlanWaitingpoint !== undefined ? Array.visitPlanWaitingpoint : 0,
    "visitplanApprovedPoint": Array.visitplanApprovedPoint !== undefined ? Array.visitplanApprovedPoint : 0,
    "projection_kpi_point": Array.projection_kpi_point !== undefined ? Array.projection_kpi_point : 0,
    "inv_transfer_trip_kpi_point": Array.inv_transfer_trip_kpi_point !== undefined ? Array.inv_transfer_trip_kpi_point : 0,
    "sale_order_kpi_point": Array.sale_order_kpi_point !== undefined ? Array.sale_order_kpi_point : 0,
  }
  this.data.count_list.push(obj1)
  console.log("data2=", this.data)
  this.brandService.updateEmployeeKpi(this.data).subscribe((res) => {
    this.alert = res.message;
    console.log("res=", res);
    this.MonthSelected()
    Swal.fire('Done!', res.message, 'success')
  })
}

  }

  calculateTotal(Array: any) {
  let total = 0;
  
  const fields = [
    'Unposted_invoices',
    'hardcopy_not_received_invoices',
    'rfr_over_due_count',
    'rfr_missed_kpi_point',
    'rft_over_due_count',
    'rft_missed_kpi_point',
    'employee_attendance_point',
    'visitPlanWaitingpoint',
    'visitplanApprovedPoint',
    'projection_kpi_point',
    'inv_transfer_trip_kpi_point',
    'sale_order_kpi_point'
  ];
  
  fields.forEach(field => {
    if (Array[field] !== undefined && Array[field] !== null) {
      total += Number(Array[field]);
    }
  });
  
  Array.total = total;
}
  handleFieldChange(item: any, field: string) {
  let value = item[field];
  if (value === undefined || value === null || value === '') {
    item[field] = 0;
  } else if (value < -999999) {
    item[field] = -999999;
  }
  this.calculateTotal(item);
}


  MonthSelected() {

    console.log("Date=", this.Date)
    if (this.user_Type == "Sales_Promoter") {

      this.brandService.viewEmployeeKpi("month_filter=" + this.Date + "&employee_id=" + this.Id).subscribe((res) => {
        this.output = res.data
        this.data._id = this.output[0]._id
        console.log("this.output", this.output)
      })

    }
    else {
      this.brandService.viewEmployeeKpi("month_filter=" + this.Date + "&employee_id=" + this.Id).subscribe((res) => {
        this.output = res.data
        this.data._id = this.output[0]._id
        console.log("this.output1", this.output)
      })
    }

  }

  getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear(); // Get the current year
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1 and ensure two digits
    return `${year}-${month}`;
  }

  //-------date formating-------------

  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe: any = null;
  DateFormat(value: any) {
    const utcDate = new Date(value); // Parse the date string as UTC
    const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000); // Convert to local timezone
     //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(localDate, 'MMM d, y');
    return this.todayWithPipe

  }
  ngOnInit(): void {

    this.Date = this.getFormattedDate();
    this.route.queryParams.subscribe((params) => {
      this.getdata = params;
      this.setData = this.getdata.setData;
      const obj = JSON.parse(this.setData);
      this.array = [obj];

      this.Data = this.array[0].data;
      this.user_Type = this.Data.Type
      this.Id = this.Data.Id
      console.log("User Data=", this.Data)
      console.log("User Type=", this.user_Type)

      this.MonthSelected()

    })
  }

}
